export default class {
	static save(name, value, days) {
		if (!window) {
			return;
		}

		let expires = '';
		if (days) {
			expires = `; expires=${(new Date((new Date()).getTime() + days * 86400000)).toUTCString()}`;
		}
		window.document.cookie = `${name}=${value || ''}; ${expires}; path=/;`;
	}

	static read(name) {
		if (!window) {
			return;
		}

		const nameEQ = `${name}=`;
		const cookies = window.document.cookie.split(';');
		for (let i = 0; i < cookies.length; i += 1) {
			let c = cookies[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	static delete(name) {
		if (!window) {
			return;
		}

		window.document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
	}
}
